/**
 * アプリケーション全体の設定
 */
// APIのベースURL。拠点ごとにビルド時環境変数 REACT_APP_API_BASE_URL で指定する。
// 例（山形）: REACT_APP_API_BASE_URL=https://api-yamagata.aomori-music.com
// 未設定なら：本番は従来の青森API、開発は localhost。
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.aomori-music.com' // 本番フォールバック（青森）
    : 'http://localhost:5000');      // 開発

const config = {
  // API設定
  API_BASE_URL,

  // API設定（新形式）
  api: {
    baseURL: API_BASE_URL,
    timeout: 30000, // 30秒
    retryDelay: 1000, // リトライ間隔（ミリ秒）
    maxRetries: 3, // 最大リトライ回数
  },

  // 認証設定
  auth: {
    tokenKey: 'auth_token',
    refreshTokenKey: 'refresh_token',
    userKey: 'user',
    expireTime: 8 * 60 * 60 * 1000 // 8時間（ミリ秒）
  },

  // アプリケーション設定
  app: {
    name: 'Dispatch Business Manager',
    version: '1.0.0',
  },

  // ページネーション設定
  PAGINATION: {
    DEFAULT_PAGE: 1,
    DEFAULT_ITEMS_PER_PAGE: 10,
    ITEMS_PER_PAGE_OPTIONS: [5, 10, 20, 50, 100]
  },

  // 日付フォーマット設定
  DATE_FORMAT: {
    DISPLAY: 'YYYY-MM-DD',
    API: 'YYYY-MM-DD',
    DATETIME: 'YYYY-MM-DD HH:mm:ss'
  },

  // アップロード設定
  UPLOAD: {
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
    ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/gif']
  },

  // デバッグ設定
  DEBUG: process.env.NODE_ENV !== 'production'
};

// デバッグ用のログ出力
if (config.DEBUG) {
  console.log('Current environment:', process.env.NODE_ENV);
  console.log('API BASE URL:', config.API_BASE_URL);
}

export default config;
